import React, { Component } from "react";

import "./style.css";

export default class QuickAccess extends Component {
  render() {
    return <div className="quick-access-container">{this.props.children}</div>;
  }
}
